import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../../chunks/tslib.es6.js";
import s from "../../core/Accessor.js";
import { JSONMap as e } from "../../core/jsonMap.js";
import a from "../../core/Logger.js";
import o from "../../core/Warning.js";
import { property as t } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import l from "./ColorVariable.js";
import n from "./OpacityVariable.js";
import c from "./RotationVariable.js";
import p from "./SizeVariable.js";
var u = a.getLogger("esri.renderers.visualVariables.VisualVariableFactory"),
    b = {
  color: l,
  size: p,
  opacity: n,
  rotation: c
},
    V = new e({
  colorInfo: "color",
  transparencyInfo: "opacity",
  rotationInfo: "rotation",
  sizeInfo: "size"
}),
    h = /^\[([^\]]+)\]$/i;

var m = /*#__PURE__*/function (_s) {
  _inherits(m, _s);

  var _super = _createSuper(m);

  function m() {
    var _this;

    _classCallCheck(this, m);

    _this = _super.apply(this, arguments), _this.colorVariables = null, _this.opacityVariables = null, _this.rotationVariables = null, _this.sizeVariables = null;
    return _this;
  }

  _createClass(m, [{
    key: "visualVariables",
    set: function set(r) {
      if (this._resetVariables(), (r = r && r.filter(function (r) {
        return !!r;
      })) && r.length) {
        var _iterator = _createForOfIteratorHelper(r),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _s3 = _step.value;

            switch (_s3.type) {
              case "color":
                this.colorVariables.push(_s3);
                break;

              case "opacity":
                this.opacityVariables.push(_s3);
                break;

              case "rotation":
                this.rotationVariables.push(_s3);
                break;

              case "size":
                this.sizeVariables.push(_s3);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (this.sizeVariables.length) {
          this.sizeVariables.some(function (r) {
            return !!r.target;
          }) && r.sort(function (r, s) {
            var e = null;
            return e = r.target === s.target ? 0 : r.target ? 1 : -1, e;
          });
        }

        for (var _s2 = 0; _s2 < r.length; _s2++) {
          r[_s2].index = _s2;
        }

        this._set("visualVariables", r);
      } else this._set("visualVariables", r);
    }
  }, {
    key: "readVariables",
    value: function readVariables(r, s, e) {
      var a = s.rotationExpression,
          t = s.rotationType,
          i = a && a.match(h),
          l = i && i[1];
      if (l && (r || (r = []), r.push({
        type: "rotationInfo",
        rotationType: t,
        field: l
      })), r) return r.map(function (r) {
        var s = V.read(r.type),
            a = b[s];
        a || (u.warn("Unknown variable type: ".concat(s)), e && e.messages && e.messages.push(new o("visual-variable:unsupported", "visualVariable of type '".concat(s, "' is not supported"), {
          definition: r,
          context: e
        })));
        var t = new a();
        return t.read(r, e), t;
      });
    }
  }, {
    key: "writeVariables",
    value: function writeVariables(r, s) {
      var e = [];

      var _iterator2 = _createForOfIteratorHelper(r),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _a = _step2.value;

          var _r = _a.toJSON(s);

          _r && e.push(_r);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return e;
    }
  }, {
    key: "_resetVariables",
    value: function _resetVariables() {
      this.colorVariables = [], this.opacityVariables = [], this.rotationVariables = [], this.sizeVariables = [];
    }
  }]);

  return m;
}(s);

r([t()], m.prototype, "visualVariables", null), m = r([i("esri.renderers.visualVariables.VisualVariableFactory")], m);
var f = m;
export { f as default };